import React, { useState } from "react";
import '../styles/safety.css';
import carIcon from "../assets/images/livetrack1.png"; 
import phoneIcon from "../assets/images/phonenum.png"; 
import supportIcon from "../assets/images/support3.png"; 

const Safety = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const isMobile = window.innerWidth <= 600;
  const questions = [
    {
      question: "How to identify my ride?",
      answer:
        "Once you have been matched with a driver, you will see your driver’s name and profile picture, vehicle's license plate number, and the car’s make, model, and color. Once your driver arrives at your pickup location, please confirm these details to ensure you are paired with the correct driver."
    },
    {
      question: "How can I rate my driver?",
      answer:
        "When your trip ends, you will have the option to rate your driver. Ratings help us provide a great experience for both drivers and riders."
    },
    {
      question: "What happens if I'm involved in an accident?",
      answer:
        "Remain calm and confirm everyone is safe. Call 911 immediately."
    }
  ];

  const toggleQuestion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const berimoItems = [
    {
      img: "security",
      title: "Background checks",
      text: "Drivers must provide their social security number upon signing up. Berymo’s third-party partners will run a national background check before gaining eligibility to drive."
    },
    {
      img: "file",
      title: "Zero tolerance policy",
      text: "To follow safety requirements, Berymo has a zero tolerance drug and alcohol policy for all drivers. Riders can easily report intoxicated drivers through our in-app function."
    },
    {
      img: "headphone",
      title: "Emergency calling",
      text: "If you are involved in an emergency, tap the Emergency button found on your driver app or call 911. We will notify local authorities immediately for your convenience."
    },
    {
      img: carIcon,
      title: "Real-Time GPS Tracking",
      text: "Track your ride in real time and follow your driver’s route from start to finish. You can also share your live location with trusted contacts for added safety."
    },
    {
      img: phoneIcon,
      title: "Masked Phone Numbers",
      text: "Your phone number stays private when contacting drivers. Our system securely masks your real number to ensure safe and anonymous communication."
    },
    {
      img: supportIcon,
      title: "Ride Insurance Protection",
      text: "Every Berymo ride includes dedicated insurance coverage. This added protection offers peace of mind for both riders and drivers during every trip."
    }
  ];

  // Helper function to determine the correct image source
  const getBerymoImageSrc = (imgSource) => {
    // Check if the source is a complete path (e.g., an imported image variable)
    if (typeof imgSource === 'string' && imgSource.includes('/')) {
      return imgSource;
    }
    // Otherwise, assume it's a filename that needs the /images/ prefix.
    return `/images/${imgSource}.png`;
  };

  return (
    <>
      <div className="safety-wrapper">
        <div className="safety-container">
          <h1 className="safety-title">
            At Berymo, safety will always be <br/>our top commitment.
          </h1>
        </div>

        <div className="berymo-container">
          <h2>Verified drivers for safer rides</h2>
          <p className="berymo-subtext">
            At Berymo we verify all of our drivers before they hit the road by running background checks,
            inspecting their vehicles and rating our drivers by checking their previous rides.
          </p>
          <div className="berymo-grid">
            {berimoItems.map((item, i) => (
              <div className="berymo-box" key={i}>
                <img 
                  src={getBerymoImageSrc(item.img)} 
                  alt={item.title} 
                  className="icon"
                  // *** MODIFICATION: Specific style logic for supportIcon ***
                  style={
                    item.img === supportIcon
                      ? { width: '39px', height: 'auto' } // Larger size for supportIcon
                      : (item.img === carIcon || item.img === phoneIcon
                          ? { width: '39px', height: 'auto' } // Standard size for other imported icons
                          : {} // Default style for non-imported icons
                        )
                  }
                />
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="safety-image">
        <img src="/images/safety.jpg" alt="safety" />
      </div>


      <div className="ram-container">
        <h2>Drivers must pass required screenings</h2>
        <p className="ram-subtext">
          Before we approve a driver at Berymo, the driver will undergo a national background check, review of driving history, drug test, and complete a knowledge check.
        </p>
        <div className="ram-grid">
          {[
            {
              img: "star",
              title: "Rating system",
              text: "Riders and drivers can rate each other after ride is complete. Ratings provide valuable feedback for continuously improving the ride share experience."
            },
            {
              img: "checklist",
              title: "Be there safe",
              text: "Pick your destination from the app. Check your drivers information from the app for a safe and hassle free ride."
            },
            {
              img: "car",
              title: "Vehicle standards",
              text: "To provide you a safe and reliable experience, all vehicles operating under Berymo Places must be at least 15 years or newer."
            }
          ].map((item, i) => (
            <div className="ram-box" key={i}>
              <img src={`/images/${item.img}.png`} alt={item.img} className="icon" />
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </div>
          ))}
        </div>
      </div>
      <div className="quote-section">
        <h1>
          Everyday hundreds of people are affected by drunk <br/>drivers. At Berymo Places, we are determined to<br/> reduce this number by providing a free rideshare<br/> service when you need it the most.
        </h1>
        {/* <h5>Sefik Bayindir, Berymo Head of Design</h5> */}
      </div>

      {/* FAQ */}
      <div className="faq-sections">
        <h1>Frequently asked questions from our rider</h1>
        <div className="faq-lists">
          {questions.map((item, index) => (
            <div
              key={index}
              className="faq-items"
              onClick={() => toggleQuestion(index)}
            >
              <div className="faq-questions">
                <span>{item.question}</span>
                <span className="plus-icon">{activeIndex === index ? "×" : "+"}</span>
              </div>
              <div className={`faq-answers ${activeIndex === index ? 'open' : ''}`}>
                {item.answer}
              </div>
            </div>
          ))}

        </div>
      </div>

    <div
    style={{
        backgroundColor: "#FEF4F5",
        clipPath: "polygon(0 7%, 100% 0, 100% 100%, 0% 100%)",
        padding: isMobile ? "120px 20px 20px" : "120px 20px 50px",
        textAlign: "center",
    }}
>
    <h1
        style={{
            fontSize: isMobile ? "20px" : "25px",
            marginBottom: isMobile ? "10px" : "17px",
            fontWeight: 700,
            lineHeight: isMobile ? "30px" : "42px",
            color: "#000",
        }}
    >
        Affordable rides are just tap away
    </h1>

    <p
        style={{
            fontSize: isMobile ? "14px" : "16px",
            color: "#555",
            lineHeight: isMobile ? "22px" : "26px",
            margin: 0,
        }}
    >
        Get affordable rides anywhere in your city and pay only $9.95 flat fee
    </p>

    {/* 👉 Wrapped button inside <a> tag */}
    <a
        href="https://apps.apple.com/us/app/berymo-free-rides-to-places/id1440035720"
        style={{ textDecoration: "none" }}
    >
        <button
            style={{
                backgroundColor: "#fd5c63",
                color: "#fff",
                border: "none",
                padding: isMobile ? "0.8rem 1.6rem" : "1rem 2.5rem",
                width: isMobile ? "42%" : "200px",
                cursor: "pointer",
                fontWeight: "bold",
                fontSize: isMobile ? "0.7rem" : "0.69rem",
                textTransform: "uppercase",
                textAlign: "center",
                fontFamily: "'Segoe UI', Arial, sans-serif",
                borderRadius: "5px",
                transition: "background-color 0.3s ease, transform 0.2s ease",
                marginTop: isMobile ? "24px" : "30px",
                marginBottom: isMobile ? "40px" : "60px",
            }}
            onMouseOver={(e) => {
                e.target.style.backgroundColor = "#474747";
                e.target.style.transform = "translateY(-2px)";
            }}
            onMouseOut={(e) => {
                e.target.style.backgroundColor = "#fd5c63";
                e.target.style.transform = "scaleX(1)";
            }}
        >
            SIGN UP TO RIDE
        </button>
    </a>
</div>



    </>
  );
};

export default Safety;